import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  indicatorId: Yup.number()
    .required('ID is required')
    .min(1, 'ID must be between 1 - 16')
    .max(16, 'ID must be between 1 - 16'),
  remoteId: Yup.string().required('Remote station is required'),
});
